
























// TODO: Добавить оверлей, если успешно, с кодом, который был ативирован и оверлей, если неудачно

import Vue from 'vue'
import { Component, VModel, Emit } from 'vue-property-decorator'

import { ActivateCouponStruct } from './types'

@Component
export default class CouponCard extends Vue {
  @VModel({ type: String }) coupon!: string

  isLoading = false

  @Emit('activateCoupon')
  public activateCoupon(): ActivateCouponStruct {
    this.isLoading = true

    return {
      coupon: this.coupon,
      closeLoading: (): void => {
        this.isLoading = false
      },
      error: (): void => {
        this.coupon = ''
        this.isLoading = false
      },
    }
  }
}
